import { useTheme } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { pricingUtils } from "@flights/web-api-utils-universal";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import useFormatPrice from "../../../../../../../hooks/useFormatPrice.js";
import { isOfMetaOrigin } from "../../../../../../../utils/marketing-url-params.js";
import web_flights_fd_genius_saving_badge_percentage from "../../../../../../../utils/experiments/genius/web_flights_fd_genius_saving_badge_percentage.js";
const useGeniusRewardsInfoController = (flight) => {
    const theme = useTheme();
    const i18n = useI18n();
    const { isLoggedIn } = useProfiler();
    const { formatPrice } = useFormatPrice();
    const showGeniusRewardsUpsellInfo = Boolean(flight.displayOptions?.showGeniusRewardsUpsellInfo);
    const hasFlightGeniusDiscount = flight.priceBreakdown?.bcomPricingItems?.some((item) => item.itemType === "GENIUS_DEAL" || item.itemType === "GENIUS_AIRLINE_FARE");
    const hasCheckedBaggageDiscount = (flight.ancillaries?.checkedInBaggage?.options.length ?? 0) > 0 &&
        flight.ancillaries?.checkedInBaggage?.options[0].priceBreakdown?.bcomPricingItems?.some((item) => item.itemType === "GENIUS_CHECKED_BAG");
    const flexTicketPriceBreakdown = flight.ancillaries?.flexibleTicket?.priceBreakdown;
    const flexTicketGeniusItem = flexTicketPriceBreakdown?.bcomPricingItems?.find((item) => item.itemType === "GENIUS_FLEXTICKET");
    const hasFlexTicketDiscount = !!flexTicketGeniusItem;
    let flexTicketDiscountPercentage;
    if (flexTicketPriceBreakdown && flexTicketGeniusItem) {
        const discountAmount = Math.abs(pricingUtils.priceToNumber(flexTicketGeniusItem.amount));
        const originalPrice = flexTicketPriceBreakdown.totalWithoutDiscount
            ? pricingUtils.priceToNumber(flexTicketPriceBreakdown.totalWithoutDiscount)
            : pricingUtils.priceToNumber(flexTicketPriceBreakdown.total) + discountAmount;
        if (originalPrice > 0) {
            flexTicketDiscountPercentage = Math.round((discountAmount / originalPrice) * 100);
        }
    }
    const upgradeBenefitMessage = showGeniusRewardsUpsellInfo
        ? i18n.trans(t("flights_fd_genius_rewards_list_item"))
        : undefined;
    const hasGeniusRewards = hasFlightGeniusDiscount || hasCheckedBaggageDiscount || hasFlexTicketDiscount || Boolean(upgradeBenefitMessage);
    const showLoadingPrice = isOfMetaOrigin();
    const experimentVariant = isLoggedIn() && web_flights_fd_genius_saving_badge_percentage.trackWithDefaultStage();
    const shouldTrackStages = isLoggedIn() && hasFlightGeniusDiscount;
    web_flights_fd_genius_saving_badge_percentage.useTrackStages(shouldTrackStages);
    let geniusSavingBadgeData;
    if (experimentVariant === 1 && flight.priceBreakdown?.totalGeniusFareDiscount) {
        geniusSavingBadgeData = {
            variant: "absolute",
            savingsAmount: formatPrice(flight.priceBreakdown.totalGeniusFareDiscount, { isDiscount: true })
        };
    }
    else if (experimentVariant === 2 && flight.priceBreakdown?.totalGeniusFareDiscountPercentage) {
        geniusSavingBadgeData = {
            variant: "percentage",
            percentageDiscount: flight.priceBreakdown.totalGeniusFareDiscountPercentage
        };
    }
    return {
        hasGeniusRewards,
        headerColor: theme.colors.color_brand_primary_background,
        subheader: i18n.trans(t("flights_fd_genius_rewards_subtitle")),
        checkedBaggageDiscount: hasCheckedBaggageDiscount && flight.ancillaries?.checkedInBaggage?.options[0],
        showCheckedBaggageLoadingPrice: showLoadingPrice,
        flexTicketDiscount: hasFlexTicketDiscount ? flight.ancillaries?.flexibleTicket : undefined,
        flexTicketDiscountPercentage,
        flightGeniusDiscount: hasFlightGeniusDiscount && i18n.trans(t("flights_fd_lower_price")),
        upgradeBenefitMessage,
        geniusSavingBadgeData
    };
};
export default useGeniusRewardsInfoController;
